<template>
  <div class="c-newsletter">
    <div class="signup" v-if="view == 'signup'">
      <div class="heading">
        {{ text.heading }}
      </div>
      <div class="manchet">
        {{ text.manchet }}
      </div>
      <div class="form">
        <input
          class="form__input"
          type="name"
          name="name"
          v-model="name"
          :placeholder="text.name"
          required
        />
        <input
          class="form__input"
          type="email"
          name="email"
          v-model="email"
          :placeholder="text.email"
          required
        />
        <div class="form__submit o-button o-button--blue" @click="submit()">
          {{ text.button }}
        </div>
      </div>
    </div>
    <div class="success" v-if="view == 'success'">
      <div class="heading">
        {{ text.success.heading }}
      </div>
      <div class="manchet">
        {{ text.success.manchet }}
      </div>
    </div>
    <div class="failed" v-if="view == 'failed'">
      <div class="heading">
        {{ text.failed.heading }}
      </div>
      <div class="manchet">
        {{ text.failed.manchet }}
      </div>

      <div class="o-button o-button--blue" @click="view = 'signup'">
        {{ text.failed.button }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Newsletter",
  data: () => {
    return {
      email: "",
      name: "",

      view: "signup",
    };
  },
  props: {
    text: {
      type: Object,
    },
    type: {
      type: String,
      default: "newsletter",
    },
  },

  methods: {
    submit() {
      let formData = new FormData();
      formData.append("email", this.email);
      formData.append("firstName", this.name);
      formData.append("type", this.type);

      axios
        .post("/wp-json/klaviyo/v1/subscribe", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (!res.data.success) {
            this.view = "failed";
            return;
          }

          this.view = "success";
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../_scss/_vars.scss";
@import "../../../_scss/utils/utils.scss";

.c-newsletter {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .heading {
    color: $c-primary;
    font-size: rem(38px);
    font-weight: $f-semibold;
    line-height: 1;
    text-align: center;
    width: 100%;
  }

  .manchet {
    color: $c-primary;
    font-size: rem(18px);
    margin-top: 24px;
  }

  .signup {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form {
    max-width: 600px;
    margin-top: 45px;
    display: flex;
    width: 100%;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;

    &__input {
      flex: 1;
      background-color: #fff;
      border: 0;
      border-radius: rem(19.5px);
      color: #000;
      font-size: rem(18px);
      font-weight: $f-medium;
      height: rem(40px);
      line-height: rem(40px);
      outline: none;
      padding-left: rem(20px);
      padding-right: rem(20px);
      width: 100%;

      min-width: 280px;

      @include placeholder {
        color: rgba($color: #000000, $alpha: 0.8);
        font-size: rem(16px);
        font-weight: $f-medium;
        line-height: rem(40px);
        position: relative;
      }
    }

    &__submit {
      cursor: pointer;
      width: 100%;
    }
  }

  .failed {
    .o-button {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/vue/Newsletter.vue